

import Vue from 'vue'
import Vuex from 'vuex'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import Home from './components/Home'
import World from './components/HelloWorld'
import RiskDetail from './components/RiskDetail'
import Posture from './components/Posture'
import PostureIpad from './components/Posture_ipad'
import Face from './components/Face'
import Error from './components/Wechat_error'
import ajax from './assets/javascripts/ajax'
import VueI18n from 'vue-i18n'
import _ from 'lodash'

import {  configLang,alreadyConfLang } from './assets/javascripts/locales.conf'
const dateTimeFormats = {
'en-US': {
short: {
year: 'numeric', month: 'short', day: 'numeric'
},
long: {
year: 'numeric',
month: 'short',
day: 'numeric',
weekday: 'short',
hour: 'numeric',
minute: 'numeric'
}
},
'ja-JP': {
short: {
year: 'numeric', month: 'short', day: 'numeric'
},
long: {
year: 'numeric',
month: 'short',
day: 'numeric',
weekday: 'short',
hour: 'numeric',
minute: 'numeric',
hour12: true
}
}
}
var pathUrl = location.href.match(/(\w+)=(\w+)(-\w+)?/g)
var pathObj = {}
for (var i = 0; i < pathUrl.length; i++) {
var pathItem = pathUrl[i].split('=')
pathObj[pathItem[0]] = pathItem[1] || ''
}

let get = (language) => {

if (_.isNil(language) || !_.isString(language)) {
console.log(`illegal language: ${language}`)
return locales.zh
}

language = language.toLowerCase()




let locale = locales[language]
if (locale) return locale


console.log(language.split('_')[0])
locale = locales[language.split('_')[0]]
if (locale) return locale
else return locales.en
}

const locales = {

'zh': 'zhHans',
'zh-hans': 'zhHans',
'zh-hant': 'zhHant',
'en': 'en',
'pt': 'pt',
'it': 'it',
'ja': 'ja',


'zh_hk': 'zhHant',
'zh_tw': 'zhHant',
'zh-hk': 'zhHant',
'zh-tw': 'zhHant'
}

var locale = get(pathObj.language)
console.log(locale);

if (get(pathObj.language) === 'zhHans') {
document.title = '体态报告'
} else if (get(pathObj.language) === 'zhHant') {
document.title = '體態報告'
}else {
document.title = 'Posture Report'
}

Vue.use(VueI18n)
const i18n = new VueI18n({
dateTimeFormats,
locale: locale,
fallbackLocale: 'cn'
})
import HelloWorld from './components/HelloWorld'

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(AjaxPlugin)
Vue.use(BusPlugin)
/*
console.log('mock',process.env.NODE_ENV)
if(process.env.NODE_ENV == 'development') {
require('../test/mock/posture')
} */

import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import BusPlugin from 'vux/src/plugins/bus/index.js'
import ConfigPlugin from 'vux/src/plugins/config/index.js'


const store = new Vuex.Store({})


store.registerModule('vux', {

state: {
direction: 'forward',
url:'',
cur_index:0,
riskData: [
{
'position': 'head',
'code': 2,
'name': '头部前倾',
'points': [
{
'x': 41.2926,
'y': 17.8695
},
{
'x': 53.8244,
'y': 18.2612
}
],
'value': 35.82379560330111,
'level': 'mild',
'description': '有头部侧倾风险（左倾）',
'valid': true
},
{
'position': 'shoulder',
'code': 1,
'name': '高低肩',
'points': [
{
'x': 36.4531,
'y': 35.6373
},
{
'x': 59.8613,
'y': 34.8457
}
],
'value': 29.378276641894587,
'level': 'severe',
'description': '有高低肩风险（左高右低）',
'valid': true
}
],
reportData: null,
locale: locale
},
getters: {
title: state => {
console.log('state:', state.title)
return state.title
},
getUrl: (state) => {
return state.url
}

},

mutations: {
updateDirection (state, payload) {
state.direction = payload.direction
},
updateUrl (state, url) {
console.log({url:url})
state.url =url
},
updateReportData (state, payload) {
state.reportData = payload.reportData
}
},

actions: {
get (context, config) {
config.http = Vue.http
ajax.get(config)
},

post (context, config) {
config.http = Vue.http
ajax.post(config)
},
delete (context, config) {
config.http = Vue.http
ajax.delete(config)
},
patch (context, config) {
config.http = Vue.http
ajax.patch(config)
}
}
})


Vue.use(ConfigPlugin, {
$layout: 'VIEW_BOX'
})


let isPhone = true
if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
isPhone = true
} else {
isPhone = false
}

const routes = [
{
path: '/home',
component: Home
},
{
path: '/world',
component: World
},
{
path: '/riskDetail',
component: RiskDetail
},
{
path: '/face',
component: Face
},
{
path: '/',
component: isPhone? Posture : PostureIpad
},
{
path: '/fascial',
component:HelloWorld
},
{
path:'/error',
component:Error
}
]

const router = new VueRouter({
routes
})


const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)


router.beforeEach(function (to, from, next) {


const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)


if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === fromIndex)) {
store.commit('updateDirection', {direction: 'forward'})
} else {
store.commit('updateDirection', {direction: 'reverse'})
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', {direction: 'forward'})
}


if (/\/http/.test(to.fullPath)) {
let url = to.fullPath.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}
})


router.afterEach(function (to) {
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
i18n,
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js